import { isNil, isEmpty, pathOr, head, match, includes } from 'ramda';
/* UniCpo
----------------------------------------------------------*/

let UniCpo, cpoMakeInstance;

UniCpo = {
    addToCartAjax:                unicpo.ajax_add_to_cart,
    addToCartBtnEl:               {},
    addToCartBtnSelector:         '.single_add_to_cart_button, button.product_type_simple',
    addedToCartMsg:               jQuery('<div class="woocommerce-message"><a href="' + wc_add_to_cart_params.cart_url + '" class="button wc-forward">' + wc_add_to_cart_params.i18n_view_cart + '</a> ' + unicpo_i18n.added_to_cart + '</div>'),
    calc:                         unicpo.calc_on,
    calcBtn:                      unicpo.calc_btn_on,
    colorifyImagifyChangers:      jQuery('.uni-cpo-colorify-imagify-changer').get(),
    cpo:                          unicpo.cpo_on,
    isTaxable:                    unicpo.taxable,
    fileUploadEl:                 {},
    flatpickrCfg:                 {},
    geocoder:                     null,
    isFlexContainer:              jQuery('.flex-viewport').length > 0,
    isLayeredOn:                  unicpo.layered_on,
    isImagify:                    unicpo.imagify_on,
    isSilentValidationOn:         unicpo.silent_validation_on,
    layeredImg:                   null,
    mainImageChangers:            jQuery('.uni-cpo-image-changer').get().reverse(),
    mainImageDefData:             {},
    mainImageEl:                  '',
    orderingDsblMsgEl:            jQuery('.js-uni-cpo-ordering-disabled-notice'),
    priceTagEl:                   {},
    priceStartingEl:              jQuery('<span class="js-cpo-price-starting"></span>'),
    priceCalculateEl:             jQuery('<span class="js-cpo-calculating"></span>'),
    productFormEl:                {},
    progressEl:                   {},
    priceSuffix:                  unicpo.price_vars.price_suffix,
    priceTaxSuffixStarting:       unicpo.price_vars.price_tax_suffix,
    pricePostfix:                 unicpo.price_vars.price_postfix,
    priceStarting:                unicpo.price_vars.starting_price,
    resetBtn:                     unicpo.reset_form_btn_on,
    taxPriceSuffixElClass:        '.woocommerce-price-suffix',
    _pid:                         0,
    _ajax_sent:                   false,
    _init:                        function() {
        try {
            if (this.cpo) {
                this.addToCartBtnEl = jQuery(this.addToCartBtnSelector);

                if (!this.addToCartBtnEl.length || this.addToCartBtnEl.length > 1) {
                    this.addToCartBtnEl = jQuery('.product.cpo-enabled-product .single_add_to_cart_button, .product.cpo-enabled-product button.product_type_simple');
                }
                if (!this.addToCartBtnEl.length) {
                    console.info('Uni CPO @', 'Add to cart button is not found');
                }
                this.productFormEl = this.addToCartBtnEl.closest('form');

                if (!this.productFormEl.length) {
                    console.info('Uni CPO @', 'Product form is not found');
                } else {
                    this.productFormEl.attr('data-parsley-focus', 'none');
                }

                if (jQuery('.qty').length > 0) {
                    const el = jQuery('.qty')[0];
                    if (isEmpty(el.min) || isNil(el.min)) {
                        jQuery('.qty').removeAttr('min');
                    }
                    if (isEmpty(el.max) || isNil(el.max)) {
                        jQuery('.qty').removeAttr('max');
                    }
                    jQuery('.qty').attr('data-parsley-trigger', 'change focusout submit');
                }
                if (this.addToCartAjax && this.addToCartBtnEl.length > 0) {
                    this.addToCartBtnEl.attr('type', 'button');
                    this.addToCartBtnEl.addClass('uni_cpo_ajax_add_to_cart');
                }
                this.priceTagEl = jQuery(unicpo.price_selector);
                if (!this.priceTagEl.length) {
                    console.info('Uni CPO @', 'Price tag html element is not found');
                }
                this.priceTaxRevTagEl = jQuery(unicpo.price_tax_rev_selector);

                this.priceStartingEl.html(this.getProperPrice());
                this.priceCalculateEl.html(unicpo_i18n.calc_text);

                if (!this.calc) {
                    this.setBtnState(true);
                }
                if (this.calc && this.calcBtn) {
                    this.setBtnState(true);
                    this.setPriceTo({ price: this.priceStartingEl });
                    this.bindOnCalcBtnClick();
                }

                this.bindOnAddToCartClick();
                this.initTooltip();

                if (typeof google === 'object' && typeof google.maps === 'object') {
                    this.geocoder = new google.maps.Geocoder();
                    this.initGoogleMap();
                } else {
                    console.info('Uni CPO @', 'Google API key is missing or invalid');
                }

                this.initRangeSlider();
                this.bindOnFileUploadClick();
                this.bindOnMatrixCellClick();

                // initial calculation
                const cpoObj = this;
                const interval = setInterval(function() {
                    if (document.readyState === 'complete') {
                        clearInterval(interval);
                        if (!cpoObj.calc || (cpoObj.calc && !cpoObj.calcBtn)) {
                            cpoObj.processFormData();
                        } else if (cpoObj.calc && cpoObj.calcBtn) {
                            cpoObj.collectData(true);
                        }
                        cpoObj.mainImageEl = cpoObj.getMainImageEl();
                        cpoObj.mainImageDefData = cpoObj.getMainImageDefData();
                        cpoObj.changeMainImage();
                        cpoObj.checkColorifyImagify();
                        jQuery(document.body).trigger('uni_cpo_frontend_is_ready');
                    }
                }, 100);

                /* <fs_premium_only> */
                const { weekdays, months, scrollTitle, toggleTitle } = unicpo_i18n.flatpickr;
                this.flatpickrCfg = {
                    locale: {
                        weekdays,
                        months,
                        daysInMonth:      [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                        firstDayOfWeek:   0,
                        ordinal:          (nth) => {
                            const s = nth % 100;
                            if (s > 3 && s < 21) return 'th';
                            switch (s % 10) {
                                case 1:
                                    return 'st';
                                case 2:
                                    return 'nd';
                                case 3:
                                    return 'rd';
                                default:
                                    return 'th';
                            }
                        },
                        rangeSeparator:   ' - ',
                        weekAbbreviation: 'Wk',
                        scrollTitle,
                        toggleTitle,
                        amPM:             ['AM', 'PM']
                    }
                };

                if (this.isLayeredOn) {
                    const $layered_image_container = jQuery(document.body).find('.uni_cpo_main_image_layered_image');
                    if ($layered_image_container.length > 0 && typeof flickty === 'undefined') {
                        jQuery('.uni-cpo-main-image-bg-colorpicker').wpColorPicker({
                            color:    '#ffffff',
                            mode:     'hsv',
                            target:   false,
                            palettes: false,
                            controls: 'strip',
                            width:    200,
                            change:   function(event, ui) {
                                //console.log(ui.color.toString());
                                jQuery('.uni_cpo_main_image_layered_image').css('background-color', ui.color.toString());
                            }
                        });
                    }
                }
                this.bindOnResetRadioBtnClick();
                if (this.resetBtn) {
                    this.bindOnResetFormBtnClick();
                }
                /* </fs_premium_only> */

                this.bindOnRadioImageTap();
                this.bindOnRadioColourClick();
                this.bindOnRadioTextClick();
                this.bindOnOptionSelected();
                this.bindImageChangers();

                this.fpdCompat();
            }
        } catch (e) {
            console.error(e);
        }
    },
    addToCart:                    function(fields) {
        const data = {
            action:   'uni_cpo_add_to_cart',
            security: unicpo.security,
            data:     fields
        };
        this.ajaxCall(data);
    },
    ajaxCall:                     function(data) {
        const cpoObj = this;
        const form = cpoObj.productFormEl[0];
        const $wc = jQuery('div.woocommerce').not('.widget');

        jQuery.ajax({
            url:        unicpo.ajax_url,
            data,
            dataType:   'json',
            method:     'POST',
            beforeSend: function() {
                cpoObj._blockForm(form);

                if (cpoObj.calc) {
                    cpoObj.setPriceTo({ price: cpoObj.priceCalculateEl, tax: 'hide' });
                    /* <fs_premium_only> */
                    cpoObj.setPriceTaxRevTo({ price: cpoObj.priceCalculateEl });
                    /* </fs_premium_only> */
                }
                if (cpoObj.addToCartAjax) {
                    $wc.find('.woocommerce-message').slideToggle(500, function() {
                        jQuery(this).remove();
                    });
                }
                // Triggers an event - on before send ajax request
                jQuery(document.body).trigger('uni_cpo_options_data_ajax_before_send', [data.data]);
            },
            error:      function() {
                cpoObj._unblockForm(form, 'error');
                cpoObj.setPriceTo({ price: cpoObj.priceStartingEl });
                /* <fs_premium_only> */
                cpoObj.setPriceTaxRevTo({ price: cpoObj.priceStartingEl });
                /* </fs_premium_only> */
            },
            success:    function(r) {
                //console.log(r);
                if (data.action === 'uni_cpo_add_to_cart') {
                    const keys = Object.keys(cpoObj.fileUploadEl);
                    if (keys.length) {
                        keys.forEach(i => {
                            const slug = jQuery('#' + i).data('slug');
                            cpoObj.fileUploadEl[i].splice();
                            jQuery(`#${slug}-files-list`).empty();
                            jQuery(`#${slug}-field`).val('').trigger('change');
                        });
                    }
                }
                if (r.success) {
                    cpoObj._unblockForm(form, 'success');

                    if (typeof r.data.redirect !== 'undefined') {
                        window.location = r.data.redirect;
                        return;
                    }

                    /* <fs_premium_only> */
                    if (!isNil(r.data.all_options_data)) {
                        cpoObj.replaceLabelsWithDynamicData(r.data.all_options_data);
                    }
                    /* </fs_premium_only> */
                    unicpo.formatted_vars = Object.assign({}, r.data.formatted_vars, r.data.nice_names_vars);
                    jQuery.extend(unicpo.price_vars, r.data.price_vars);
                    jQuery.extend(unicpo.extra_data, r.data.extra_data);
                    unicpo.errors = {};
                    if (!isEmpty(r.data.errors)) {
                        jQuery.extend(unicpo.errors, r.data.errors);
                    }

                    if (typeof r.data.extra_data !== 'undefined'
                        && typeof r.data.extra_data.order_product !== 'undefined' && r.data.extra_data.order_product === 'disabled') {
                        cpoObj.orderingDsblMsgEl.slideDown(300);
                        cpoObj.setBtnState(true);
                    } else {
                        cpoObj.orderingDsblMsgEl.hide();
                        cpoObj.setBtnState(false);
                    }

                    if (cpoObj.calc) {
                        const calcPrice = cpoObj.getProperPrice({
                            price:          unicpo.price_vars.price,
                            doRemoveSuffix: true
                        });
                        if (unicpo.price_vars.raw_price) {
                            cpoObj.setPriceTo({ price: calcPrice, tax: 'show' });
                            /* <fs_premium_only> */
                            cpoObj.setPriceTaxRevTo({ price: unicpo.price_vars.price_tax_rev });
                            /* </fs_premium_only> */
                        } else {
                            cpoObj.setPriceTo({ price: cpoObj.priceStartingEl });
                            /* <fs_premium_only> */
                            cpoObj.setPriceTaxRevTo({ price: cpoObj.priceStartingEl });
                            /* </fs_premium_only> */
                            cpoObj.setBtnState(true);
                        }
                    }

                    if (typeof r.data.fragments !== 'undefined') {
                        // Redirect to cart option
                        if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
                            window.location = wc_add_to_cart_params.cart_url;
                            return;
                        }

                        $wc.html(cpoObj.addedToCartMsg);

                        jQuery.each(r.data.fragments, function(key, value) {
                            jQuery(key).replaceWith(value);
                        });

                        // Trigger event so themes can refresh other areas.
                        jQuery(document.body).trigger('uni_cpo_added_to_cart', [r.data]);
                        jQuery(document.body).trigger('added_to_cart', [r.data.fragments]);

                    } else {
                        // Triggers an event - on successful ajax request
                        jQuery(document.body).trigger('uni_cpo_options_data_ajax_success', [data.data, r.data]);
                    }
                } else {
                    cpoObj._unblockForm(form, 'error');
                    if (cpoObj.calc) {
                        cpoObj.setPriceTo({ price: cpoObj.priceStartingEl });
                        /* <fs_premium_only> */
                        cpoObj.setPriceTaxRevTo({ price: cpoObj.priceStartingEl });
                        /* </fs_premium_only> */
                    }

                    if (r.data.product_url) {
                        window.location = r.data.product_url;
                        return;
                    }

                    // Triggers an event - on failure ajax request
                    jQuery(document.body).trigger('uni_cpo_options_data_ajax_fail', [data.data, r]);
                }
            }
        });
    },
    bindImageChangers:            function() {
        /* <fs_premium_only> */
        const cpoObj = this;

        jQuery(document).on('change', cpoObj.mainImageChangers, function() {
            cpoObj.changeMainImage();
        });
        /* </fs_premium_only> */
    },
    bindOnAddToCartClick:         function() {
        const cpoObj = this;

        jQuery(document).on('click', '.storefront-sticky-add-to-cart__content-button', function(e) {
            cpoObj.formSubmission();
            e.preventDefault();
        });

        if (!this.addToCartAjax) {
            jQuery(document).on('click', this.addToCartBtnSelector, function(e) {
                e.preventDefault();
                cpoObj.formSubmission();
            });
        } else {
            jQuery(document).on('click', '.uni_cpo_ajax_add_to_cart', function(e) {
                e.preventDefault();
                cpoObj.formSubmission();
            });
        }
    },
    bindOnCalcBtnClick:           function() {
        const cpoObj = this;
        jQuery(document).on('click', '.js-uni-cpo-calculate-btn', function() {
            if (cpoObj._ajax_sent) {
                return false;
            }
            cpoObj.processFormData();
        });
    },
    bindOnResetFormBtnClick:      function() {
        const cpoObj = this;
        jQuery(document).on('click', '.js-uni-cpo-reset-form-btn', function() {
            const $fieldsToProcess = jQuery(unicpo.options_selector);

            $fieldsToProcess.each(function() {
                if (!this.name) {
                    return;
                }

                const el = this;
                const $el = jQuery(el);
                const $module = $el.closest('.uni-module');
                const elType = el.type || el.tagName.toLowerCase();

                if ('checkbox' === elType || 'radio' === elType) {
                    $el.attr('checked', false);
                    cpoObj.layeredImg = '';
                } else if ('select-one' === elType || 'textarea' === elType) {
                    $el.val('');
                } else if ('number' === elType || 'text' === elType) {
                    if ($el.hasClass('js-uni-cpo-field-range_slider')) {
                        const slider = $el.data('ionRangeSlider');
                        const min = $el.attr('data-min');
                        const max = $el.attr('data-max');
                        const $input = $el.siblings(jQuery('.js-uni-cpo-field-range_slider-additional-field'));

                        slider.update({
                            from: min,
                            to:   max
                        });
                        $input.val(min);
                        return;
                    } else if ($el.hasClass('flatpickr-input')) {
                        const fp = el._flatpickr;
                        fp.clear();
                    }

                    $el.val('');
                } else if ('hidden' === elType) {
                    if ($module.hasClass('uni-module-matrix')) {
                        $module.find('.uni-clicked').removeClass('uni-clicked');
                    }
                    if ($module.hasClass('uni-module-file_upload')) {
                        const $btn = $module.find('.uni-cpo-file-upload-files-item-remove');

                        $btn.each(function() {
                            jQuery(this).trigger('click');
                        });

                    }
                    $el.val('');
                } else {
                    $el.val('');
                }
            });
            cpoObj.processFormData();
        });
    },
    bindOnFileUploadClick:        function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        const $fileUploadFields = jQuery('.js-uni-cpo-field-file_upload-el');

        if ($fileUploadFields.length) {
            $fileUploadFields.each(function() {
                const $el = jQuery(this);
                const id = $el.attr('id');
                const listId = $el.parent('.dndWrapper').siblings('.js-uni-cpo-file-upload-files').attr('id');

                const { postId, slug, maxFilesize, mimeTypes } = $el.data();

                cpoObj.fileUploadEl[id] = new plupload.Uploader({
                    max_files:        1,
                    multi_selection:  false,
                    runtimes:         'html5',
                    url:              unicpo.ajax_url,
                    browse_button:    id,
                    drop_element:     id,
                    chunk_size:       '1mb',
                    filters:          {
                        max_file_size: (maxFilesize) ? maxFilesize + 'mb' : unicpo.max_file_size + 'mb',
                        mime_types:    [
                            {
                                title:      'Allowed formats',
                                extensions: (mimeTypes) ? mimeTypes : unicpo.mime_types
                            }
                        ]
                    },
                    listId,
                    uploadMode:       'single',
                    multipart_params: {
                        action:    'uni_cpo_upload_file',
                        postId,
                        slug,
                        productId: unicpo.pid,
                        security:  unicpo.security
                    }
                });

                cpoObj.fileUploadEl[id].bind('PostInit', cpoObj.handlePluploadInit);
                cpoObj.fileUploadEl[id].bind('Error', cpoObj.handlePluploadError);
                cpoObj.fileUploadEl[id].bind('FileFiltered', cpoObj.handlePluploadFileFiltered);
                cpoObj.fileUploadEl[id].bind('FilesAdded', cpoObj.handlePluploadFilesAdded);
                cpoObj.fileUploadEl[id].bind('BeforeUpload', cpoObj.handlePluploadBeforeUpload);
                cpoObj.fileUploadEl[id].bind('UploadProgress', cpoObj.handlePluploadUploadProgress);
                cpoObj.fileUploadEl[id].bind('ChunkUploaded', cpoObj.handlePluploadChunkUploaded);
                cpoObj.fileUploadEl[id].bind('FileUploaded', cpoObj.handlePluploadFileUploaded);
                cpoObj.fileUploadEl[id].init();

                $el.on('dragenter', () => {
                    $el.addClass('dragStarted');
                });
                $el.on('dragleave', () => {
                    $el.removeClass('dragStarted');
                });
                $el.on('drop', () => {
                    $el.removeClass('dragStarted');
                });

            });
        }
        /* </fs_premium_only> */
    },
    bindOnOptionSelected:         function() {
        const cpoObj = this;
        jQuery(document).on('change', unicpo.options_selector_change, function() {
            if (cpoObj._ajax_sent) {
                return false;
            }
            const value = jQuery(this).val();
            if (jQuery(this).hasClass('js-uni-cpo-field-select')) {
                jQuery(this).attr('data-value', value);
            }
            if (jQuery(this).hasClass('js-uni-cpo-field-radio')) {
                jQuery(this).closest('.uni-module-radio').attr('data-value', value);
            }
            if (!cpoObj.calc || (cpoObj.calc && !cpoObj.calcBtn)) {
                cpoObj.processFormData();
            } else if (cpoObj.calc && cpoObj.calcBtn) {
                cpoObj.setBtnState(true);
                cpoObj.collectData(true);
            }
        });
        /* <fs_premium_only> */
        jQuery(document.body).on('DOMSubtreeModified', '[ng-bind-html=\'final_price | to_trusted\']', function(e) {
            if (cpoObj._ajax_sent) {
                return false;
            }
            if (!cpoObj.calc || (cpoObj.calc && !cpoObj.calcBtn)) {
                cpoObj.processFormData();
            } else if (cpoObj.calc && cpoObj.calcBtn) {
                cpoObj.setBtnState(true);
                cpoObj.collectData(true);
            }
        });
        /* </fs_premium_only> */
    },
    bindOnResetRadioBtnClick:     function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        jQuery('.uni-module-radio .js-uni-cpo-field-radio-reset-button').on('click', function(e) {
            e.preventDefault();
            const els = jQuery(this).closest('.uni-module-radio').find('input[type=\'radio\']');

            [...els].forEach((el) => {
                el.checked = false;
                el.setAttribute('checked', false);
            });
            cpoObj.processFormData();
        });
        /* </fs_premium_only> */
    },
    bindOnRadioColourClick:       function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        jQuery('.uni-module-radio .uni-cpo-option-label__colour-wrap').on('click', function() {
            const $el = jQuery(this);
            const data = $el.data();
            const $optionWrapper = $el.closest('.uni-module-radio');
            const optionName = $optionWrapper.attr('id');
            const isLayeredUsedByOption = $optionWrapper.data('layered');
            const isImagifyUsedByOption = $optionWrapper.data('imagify');
            if (typeof isLayeredUsedByOption !== 'undefined' && cpoObj.isLayeredOn) {
                cpoObj.showLastThumb();
                cpoObj.colorify(optionName, data.hex);
            } else if (typeof isImagifyUsedByOption !== 'undefined' && cpoObj.isImagify) {
                cpoObj.showLastThumb();
                cpoObj.imagify(optionName, data.image);
            }
        });
        /* </fs_premium_only> */
    },
    bindOnRadioTextClick:         function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        jQuery('.uni-module-radio .uni-cpo-option-label__text, .uni-module-radio .uni-cpo-option-label__radio, .uni-module-radio .uni-cpo-option-label__text-content').on('click', function() {
            const $el = jQuery(this);
            const data = $el.data();
            const $optionWrapper = $el.closest('.uni-module-radio');
            const optionName = $optionWrapper.attr('id');
            const isImagifyUsedByOption = $optionWrapper.data('imagify');
            if (typeof isImagifyUsedByOption !== 'undefined' && cpoObj.isImagify) {
                cpoObj.showLastThumb();
                cpoObj.imagify(optionName, data.image);
            }
        });
        /* </fs_premium_only> */
    },
    bindOnRadioImageTap:          function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        jQuery('.uni-cpo-option-label__image-wrap').on('click', function() {
            const $el = jQuery(this);
            const data = $el.data();
            const $optionWrapper = $el.closest('.uni-module-radio');
            const optionName = $optionWrapper.attr('id');
            const isImagifyUsedByOption = $optionWrapper.data('imagify');
            if (typeof isImagifyUsedByOption !== 'undefined' && cpoObj.isImagify) {
                cpoObj.showLastThumb();
                cpoObj.imagify(optionName, data.image);
            }
        });
        /* </fs_premium_only> */
    },
    bindOnMatrixCellClick:        function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        const $matrix = jQuery('.uni-module-matrix');
        const $cells = jQuery('.uni-module-matrix table td span');

        $cells.on('click', function() {
            const $cell = jQuery(this);
            const val = parseFloat($cell.text().replace(/,/, ''));
            const $wrap = $cell.closest('.uni-module-matrix');
            const slug = $wrap.attr('id');

            if (!$cell.hasClass('uni-clicked')) {
                const col = $cell.data('col');
                const row = $cell.data('row');

                $wrap.find('td span.uni-clicked').removeClass('uni-clicked');
                $cell.addClass('uni-clicked');

                $wrap.find('[name="' + slug + '_col"]').val(col);
                $wrap.find('[name="' + slug + '_row"]').val(row);
                $wrap.find('[name="' + slug + '"]').val(val).trigger('change');

            } else {
                $cell.removeClass('uni-clicked');

                $wrap.find('[name="' + slug + '_col"]').val('');
                $wrap.find('[name="' + slug + '_row"]').val('');
                $wrap.find('[name="' + slug + '"]').val('').trigger('change');
            }

            if (cpoObj._ajax_sent) {
                return false;
            }
            if (!cpoObj.calc || (cpoObj.calc && !cpoObj.calcBtn)) {
                cpoObj.processFormData();
            } else if (cpoObj.calc && cpoObj.calcBtn) {
                cpoObj.setBtnState(true);
                cpoObj.collectData(true);
            }
        });

        $matrix.each(function() {
            const $this = jQuery(this);
            const option = $this.attr('id');
            const col = $this.find('[name="' + option + '_col"]').val();
            const row = $this.find('[name="' + option + '_row"]').val();

            $this.find('span[data-col="' + col + '"][data-row="' + row + '"]').addClass('uni-clicked');
        });
        /* </fs_premium_only> */
    },
    calculate:                    function(fields) {
        const data = {
            action:   'uni_cpo_price_calc',
            security: unicpo.security,
            data:     fields
        };

        this.ajaxCall(data);
    },
    changeMainImage:              function() {
        /* <fs_premium_only> */
        const cpoObj = this;

        if (!this.mainImageChangers.length || !cpoObj.mainImageEl) {
            return;
        }

        let $firstChosenEl;
        this.mainImageChangers.forEach(function(el) {
            if (typeof $firstChosenEl === 'undefined') {
                const $el = jQuery(el);
                const type = $el.attr('type');

                if (!$el.hasClass('uni-cpo-excluded-field')) {
                    if ('radio' === type || 'checkbox' === type) {
                        if (true === $el.prop('checked')) {
                            $firstChosenEl = $el;
                        }
                    } else {
                        $firstChosenEl = $el;
                    }
                }
            }
        });

        const data = typeof $firstChosenEl !== 'undefined'
            ? $firstChosenEl.data()
            : this.mainImageDefData;

        this.replaceMainImageData(data);
        /* </fs_premium_only> */
    },
    checkColorifyImagify:         function() {
        /* <fs_premium_only> */
        const cpoObj = this;

        if (!(cpoObj.isLayeredOn || cpoObj.isImagify) && !cpoObj.colorifyImagifyChangers.length) {
            return;
        }

        cpoObj.colorifyImagifyChangers.forEach(function(el) {
            if (!el.classList.contains('uni-cpo-excluded-field')) {
                if ('radio' === el.type) {
                    if (el.checked) {
                        const span = el.nextElementSibling.children[0];
                        const hex = span.getAttribute('data-hex');
                        const image = span.getAttribute('data-image');
                        const wrapper = el.parentElement;
                        const wrapperId = wrapper.getAttribute('id');
                        const isColorify = wrapper.getAttribute('data-layered');
                        const isImagify = wrapper.getAttribute('data-imagify');

                        if (typeof isImagify !== 'undefined' && cpoObj.isLayeredOn) {
                            cpoObj.colorify(wrapperId, hex);
                        } else if (typeof isColorify !== 'undefined' && cpoObj.isImagify) {
                            cpoObj.imagify(wrapperId, image);
                        }
                    }
                }
            }
        });
        /* </fs_premium_only> */
    },
    collectData:                  function(isForConditional, formFields = {}) {
        const cpoObj = this;
        let fields = {};
        const $fieldsToProcess = jQuery(unicpo.options_selector).not('.uni-cpo-excluded-field');

        $fieldsToProcess.each(function() {
            if (!this.name) {
                return;
            }

            const el = this;
            const $el = jQuery(el);
            const elType = el.type || el.tagName.toLowerCase();

            if ('checkbox' === elType) {
                const name = el.name.replace('[]', '');
                if (typeof fields[name] !== 'undefined') {
                    return;
                }
                fields[name] = jQuery.makeArray(fields[name]);

                jQuery('input[name="' + el.name + '"]:checked').each(function() {
                    fields[name].push(this.value);
                });
                fields[name + '_count'] = fields[name].length;

            } else if ('radio' === elType) {
                if (jQuery('input[name="' + el.name + '"]:checked').length) {
                    if (true === $el.prop('checked')) {
                        fields[el.name] = $el.val();
                    }
                } else {
                    fields[el.name] = '';
                }
            } else if ('select-one' === elType) {
                fields[el.name] = $el.val();
            } else if ('number' === elType || 'text' === elType) {
                if ($el.hasClass('js-uni-cpo-field-datepicker')) {
                    const fp = document.getElementById(el.name + '-field')._flatpickr;
                    const mode = fp.config.mode;
                    const isDatepickerDisabled = fp.config.noCalendar;
                    const isTimepicker = fp.config.enableTime;
                    const isTime24hr = fp.config.time_24hr;

                    if (isDatepickerDisabled && isTimepicker) {
                        const startTime = moment(fp.selectedDates[0]);
                        if (isTime24hr) {
                            fields[el.name] = startTime.format('H:mm');
                            fields[el.name + '_start'] = startTime.format('H:mm');
                        } else {
                            fields[el.name] = startTime.format('h:mm a');
                            fields[el.name + '_start'] = startTime.format('h:mm a');
                        }
                    } else {
                        const startDate = moment(fp.selectedDates[0]);
                        if (mode === 'single') {
                            if (isTimepicker) {
                                if (isTime24hr) {
                                    fields[el.name] = startDate.format('Y-MM-DD H:mm');
                                    fields[el.name + '_start'] = startDate.format('Y-MM-DD H:mm');
                                } else {
                                    fields[el.name] = startDate.format('Y-MM-DD h:mm a');
                                    fields[el.name + '_start'] = startDate.format('Y-MM-DD h:mm a');
                                }
                            } else {
                                fields[el.name] = startDate.format('Y-MM-DD');
                                fields[el.name + '_start'] = startDate.format('Y-MM-DD');
                            }
                            fields[el.name + '_duration'] = 1;
                        } else if (mode === 'range') {
                            const endDate = moment(fp.selectedDates[1]);
                            if (fp.selectedDates.length) {
                                if (isTimepicker) {
                                    if (isTime24hr) {
                                        fields[el.name] = startDate.format('Y-MM-DD H:mm') + ' - ' + endDate.format('Y-MM-DD H:mm');
                                        fields[el.name + '_start'] = startDate.format('Y-MM-DD H:mm');
                                        fields[el.name + '_end'] = endDate.format('Y-MM-DD H:mm');
                                    } else {
                                        fields[el.name] = startDate.format('Y-MM-DD h:mm a') + ' - ' + endDate.format('Y-MM-DD h:mm a');
                                        fields[el.name + '_start'] = startDate.format('Y-MM-DD h:mm a');
                                        fields[el.name + '_end'] = endDate.format('Y-MM-DD h:mm a');
                                    }
                                } else {
                                    fields[el.name] = startDate.format('Y-MM-DD') + ' - ' + endDate.format('Y-MM-DD');
                                    fields[el.name + '_start'] = startDate.format('Y-MM-DD');
                                    fields[el.name + '_end'] = endDate.format('Y-MM-DD');
                                }
                                fields[el.name + '_duration'] = endDate.diff(startDate, 'days');
                                if ($el.hasClass('js-datepicker-day-night-mode-days')) {
                                    fields[el.name + '_duration'] = fields[el.name + '_duration'] + 1;
                                }
                            }
                        } else if (mode === 'multiple') {
                            if (fp.selectedDates.length) {
                                fields[el.name] = $el.val();
                                fields[el.name + '_duration'] = fp.selectedDates.length;
                                fields[el.name + '_days'] = [];

                                fp.selectedDates.forEach(function(item, i) {
                                    let day;
                                    if (isTimepicker) {
                                        if (isTime24hr) {
                                            day = moment(item).format('Y-MM-DD H:mm');
                                        } else {
                                            day = moment(item).format('Y-MM-DD h:mm a');
                                        }
                                    } else {
                                        day = moment(item).format('Y-MM-DD');
                                    }
                                    fields[el.name + '_days'].push(day);
                                });
                            }
                        }
                    }
                } else if ($el.hasClass('js-uni-cpo-field-range_slider')) {
                    const slider = $el.data('ionRangeSlider');
                    if ('double' === slider.options.type) {
                        const values = $el.val().split('-');
                        fields[el.name] = $el.val();
                        fields[el.name + '_from'] = values[0];
                        fields[el.name + '_to'] = values[1];
                    } else {
                        fields[el.name] = $el.val();
                        fields[el.name + '_from'] = $el.val();
                        fields[el.name + '_to'] = $el.val();
                    }
                } else if ($el.hasClass('js-uni-cpo-field-distance_by_postcode')) {
                    const origin = el.parentElement.querySelector(`[name=${el.name}_origin]`);
                    if (origin) {
                        fields[el.name + '_origin'] = jQuery(origin).val();
                    }
                    fields[el.name] = $el.val();
                } else if ($el.hasClass('js-uni-cpo-field-google_map')) {
                    const $latlng = $el.prev();

                    fields[el.name] = $el.val();
                    fields[el.name + '_latlng'] = $latlng.val();
                } else {
                    if (cpoObj.isNumber($el.val())) {
                        const val = $el.val().replace(/,/, '.');
                        $el.val(val);
                        fields[el.name] = $el.val();
                    } else {
                        fields[el.name] = $el.val();
                    }
                    fields[el.name + '_count_spaces'] = fields[el.name].length;
                    const withoutSpaces = $el.val().replace(/ /g, '');
                    fields[el.name + '_count'] = withoutSpaces.length;
                }
            } else if ('textarea' === elType) {
                fields[el.name] = $el.val();
                fields[el.name + '_count_spaces'] = fields[el.name].length;
                const withoutSpaces = $el.val().replace(/ /g, '');
                fields[el.name + '_count'] = withoutSpaces.length;
            } else if ('hidden' === elType) {
                if ($el.hasClass('js-uni-cpo-field-file_upload')) {
                    const data = $el.data();
                    fields[el.name] = $el.val();
                    if (typeof data.imageWidth !== 'undefined') {
                        fields[el.name + '_width'] = parseInt(data.imageWidth);
                    }
                    if (typeof data.imageHeight !== 'undefined') {
                        fields[el.name + '_height'] = parseInt(data.imageHeight);
                    }
                } else {
                    fields[el.name] = $el.val();
                }
            } else {
                fields[el.name] = $el.val();
            }

            // Triggers an event - for each field
            if (isForConditional) {
                jQuery(document.body).trigger('uni_cpo_option_data_for_conditional', [fields, $el]);
            } else {
                jQuery(document.body).trigger('uni_cpo_option_data_before_validate', [fields, $el]);
            }
        });

        /* <fs_premium_only> */
        //nb design integration
        const $nbdFinalPriceTag = jQuery('[ng-bind-html=\'final_price | to_trusted\']');
        if ($nbdFinalPriceTag.length) {
            fields['nbdFinalPrice'] = parseFloat($nbdFinalPriceTag.text().replace(/[^0-9\.]+/g, ''));
        }
        /* </fs_premium_only> */

        if (isForConditional) {
            const cpoFields = jQuery(document.body).triggerHandler('uni_cpo_options_data_for_conditional', [fields]);
            if (typeof cpoFields !== 'undefined') {
                fields = cpoFields;
            }
            if (!_.isEqual(formFields, fields)) {
                return cpoObj.collectData(true, fields);
            }
        } else {
            const cpoFields = jQuery(document.body).triggerHandler('uni_cpo_options_data_before_validate', [fields]);
            if (typeof cpoFields !== 'undefined') {
                fields = cpoFields;
            }
        }

        return fields;
    },
    colorify:                     function(optionName, hex) {
        /* <fs_premium_only> */
        const cpoObj = this;
        const $layer = jQuery('#palette-layer-' + optionName);

        if ($layer.length > 0) {
            const colorRgb = cpoObj.hexToRgb(hex);

            // gets main product image size
            const width = $layer.width();
            const height = $layer.height();

            cpoObj.loadImage($layer[0].src)
                .then((image) => {
                    // gets original image size
                    const w = image.width;
                    const h = image.height;
                    image.remove();

                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = w;
                    canvas.height = h;

                    ctx.drawImage($layer.get(0), 0, 0);
                    const imgd = ctx.getImageData(0, 0, w, h);
                    const pix = imgd.data;
                    const unique_color = [colorRgb.r, colorRgb.g, colorRgb.b];

                    // Loops through all of the pixels and modifies the components.
                    for (let i = 0, n = pix.length; i < n; i += 4) {
                        pix[i] = unique_color[0];
                        pix[i + 1] = unique_color[1];
                        pix[i + 2] = unique_color[2];
                    }

                    ctx.putImageData(imgd, 0, 0);

                    // put the new image to the DOM
                    $layer.attr('src', canvas.toDataURL('image/png'));
                    $layer.attr('width', width);
                    $layer.attr('height', height);
                    UniCpo.combineImg();
                }).catch((err) => {
            });
        }
        /* </fs_premium_only> */
    },
    combineImg:                   function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        const imagesWrapper = document.getElementById('uni_cpo_layered_image');
        const images = [...imagesWrapper.children].filter(el => !el.classList.contains('uni-cpo-excluded-img'));

        const canvas = document.getElementById('uni_canvas');
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);

        if (images.length) {
            canvas.width = imagesWrapper.clientWidth;
            canvas.height = imagesWrapper.clientHeight;

            Promise
                .all(images
                    .filter(i => i.tagName === 'IMG')
                    .map(i => {
                        return cpoObj.loadImage(i.src);
                    }))
                .then((images) => {
                    images.forEach((image) => {
                        context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    });
                    UniCpo.layeredImg = canvas.toDataURL();
                }).catch((err) => {
                //console.error(err);
            });
        }
        /* </fs_premium_only> */
    },
    loadImage:                    function(imagePath) {
        /* <fs_premium_only> */
        return new Promise((resolve, reject) => {
            let image = new Image();
            image.addEventListener('load', () => {
                resolve(image);
            });
            image.addEventListener('error', (err) => {
                reject(err);
            });
            image.src = imagePath;
        });
        /* </fs_premium_only> */
    },
    imagify:                      function(optionName, image) {
        /* <fs_premium_only> */
        const $layer = jQuery('#imagify-layer-' + optionName);

        if ($layer.length > 0) {
            $layer.attr('src', image);
        }

        UniCpo.combineImg();
        /* </fs_premium_only> */
    },
    formSubmission:               function() {
        const cpoObj = this;
        let excluded = '[disabled], .uni-cpo-excluded-field';

        // validates the form
        cpoObj.productFormEl.parsley({
            excluded
        }).validate();

        if (cpoObj.productFormEl.parsley().isValid()) {
            const $excludeFromFormSubmission = jQuery('.uni-cpo-excluded-field');
            $excludeFromFormSubmission.each(function() {
                jQuery(this).prop('disabled', true);
            });

            let isLayeredImagesExcluded = true;
            $('#uni_cpo_layered_image > img').each(function() {
                if (!$(this).hasClass('uni-cpo-excluded-img')) {
                    isLayeredImagesExcluded = false;
                }
            });

            jQuery('input[name="cpo_product_layered_image"]').val(isLayeredImagesExcluded ? '' : cpoObj.layeredImg);

            // regular form submission or via ajax
            if (!cpoObj.addToCartAjax) {
                cpoObj.productFormEl.submit();
            } else {
                const data = {};
                jQuery.each(cpoObj.productFormEl.serializeArray(), function(index, item) {
                    if (item.name.indexOf('nbd-field') !== -1) {
                        /* <fs_premium_only> */
                        let nbdFieldKey = head(match(/\[(.*?)\]/g, item.name));
                        if (!isNil(nbdFieldKey)) {
                            nbdFieldKey = nbdFieldKey.replace('[', '').replace(']', '');
                            if (isNil(data['nbd-field'])) {
                                data['nbd-field'] = {};
                            }
                            data['nbd-field'] = Object.assign(
                                {}, data['nbd-field'], { [nbdFieldKey]: item.value }
                            );
                        }
                        /* </fs_premium_only> */
                    } else if (item.name.indexOf('[]') !== -1) {
                        item.name = item.name.replace('[]', '');
                        data[item.name] = jQuery.makeArray(data[item.name]);
                        data[item.name].push(item.value);
                    } else {
                        data[item.name] = item.value;
                    }
                });
                /* <fs_premium_only> */
                //nb design integration
                const $nbdFinalPriceTag = jQuery('[ng-bind-html=\'final_price | to_trusted\']');
                if ($nbdFinalPriceTag.length) {
                    data['nbdFinalPrice'] = parseFloat($nbdFinalPriceTag.text().replace(/[^0-9\.]+/g, ''));
                }
                /* </fs_premium_only> */

                cpoObj.addToCart(data);
            }

            $excludeFromFormSubmission.each(function() {
                jQuery(this).prop('disabled', false);
            });
        }
    },
    getMainImageDefData:          function() {
        /* <fs_premium_only> */
        if (!this.mainImageEl) {
            console.info('Uni CPO @', 'No main image found.');
            return;
        }
        const $a = this.mainImageEl.find('a');
        const $img = $a.find('img');

        return {
            imgId:                 unicpo.product_image_id,
            imgFullUri:            $a.attr('href'),
            imgTitle:              $img.attr('title'),
            imgAlt:                $img.attr('alt'),
            imgUri:                $img.attr('src'),
            imgSrcset:             $img.attr('srcset'),
            imgSrc:                $img.attr('data-src'),
            imgLarge_image:        $img.attr('data-large_image'),
            imgLarge_image_width:  $img.attr('data-large_image_width'),
            imgLarge_image_height: $img.attr('data-large_image_height'),
            imgThumbUri:           $img.closest('[data-thumb]').attr('data-thumb'),
            imgWidth:              $img.attr('width'),
            imgHeight:             $img.attr('height')
        };
        /* </fs_premium_only> */
    },
    getMainImageEl:               function() {
        const $image = jQuery(unicpo.image_selector).find('.woocommerce-product-gallery__image');
        return $image.length > 0
            ? $image.not('.clone').first()
            : '';
    },
    getFormattedFormData:         function() {
        const pid = jQuery('.js-cpo-pid').val();
        const $prodQtyInput = this.productFormEl.find('.input-text.qty');
        const prodQty = ($prodQtyInput.val()) ? $prodQtyInput.val() : 1;
        let fields = {};
        fields['product_id'] = pid;
        fields['quantity'] = parseFloat(prodQty);
        fields = jQuery.extend(fields, this.collectData(false));
        return fields;
    },
    handlePluploadInit:           function(uploader) {
        /* <fs_premium_only> */
        const cpoObj = window.UniCpo;
        const list = uploader.settings.listId;
        const $option = jQuery('#' + uploader.settings.multipart_params.slug + '-field');

        if ($option.val() !== '') {
            const name = $option.data('filename');
            let item = '<li class="uni-cpo-file-upload-files-item">' +
                '<i class="uni-cpo-file-upload-files-item-icon"></i>' +
                '<span class="uni-cpo-file-upload-files-item-title">' + name + '</span>' +
                '<span class="uni-cpo-file-upload-files-item-uploaded" style="display: inline;"></span>' +
                '<button type="button" data-attach_id="' + $option.val() + '" class="uni-cpo-file-upload-files-item-remove"></button>' +
                '</li>';
            jQuery('#' + list).append(item);
        }

        jQuery(document).on('click', '#' + list + ' .uni-cpo-file-upload-files-item-upload', function(e) {
            e.preventDefault();
            uploader.start();
        });

        jQuery(document).on('click', '#' + list + ' .uni-cpo-file-upload-files-item-remove', function(e) {
            e.preventDefault();
            const $el = jQuery(e.target);
            const fileId = $el.data('file-id');
            const attach_id = $el.data('attach_id');
            const dropboxPath = $el.data('dropboxPath');
            const $li = $el.closest('li');
            const $list = $el.closest('.js-uni-cpo-file-upload-files');
            const $option = jQuery('#' + uploader.settings.multipart_params.slug + '-field');
            window.UniCpo.parsleyRemoveError($option);

            if (typeof attach_id !== 'undefined') {
                const data = {
                    action:   'uni_cpo_remove_file',
                    security: unicpo.security,
                    attach_id,
                    dropboxPath
                };

                jQuery.ajax({
                    url:        unicpo.ajax_url,
                    data,
                    dataType:   'json',
                    method:     'POST',
                    beforeSend: function() {
                        cpoObj._blockForm($list);
                    },
                    error:      function() {
                        cpoObj._unblockForm($list, 'error');
                    },
                    success:    function(r) {
                        if (r.success) {
                            cpoObj._unblockForm($list, 'success');
                            if (typeof fileId !== 'undefined') {
                                uploader.removeFile(fileId);
                            }
                            $li.remove();
                            $option.val('').trigger('change');
                        } else {
                            cpoObj._unblockForm($list, 'error');
                        }
                    }
                });
            } else {
                const files = uploader.files.filter((o) => {
                    if (typeof fileId !== 'undefined') {
                        return o.id === fileId;
                    }
                });
                if (files.length) {
                    uploader.removeFile(files[0]);
                }
                $li.remove();
                $option.trigger('change');
            }
        });
        /* </fs_premium_only> */
    },
    handlePluploadError:          function(uploader, error) {
        /* <fs_premium_only> */
        const $option = jQuery('#' + uploader.settings.multipart_params.slug + '-field');
        const list = uploader.settings.listId;
        window.UniCpo.parsleyRemoveError($option);

        if (-601 === error.code) {
            $option.parsley().addError('file-type', { message: 'This type of files cannot be uploaded.' });
        } else if (-600 === error.code) {
            $option.parsley().addError('file-size', { message: 'The file is too big' });
        } else {
            $option.parsley().addError('file-custom', { message: error.message });
        }

        window.UniCpo.position($option, 0);
        jQuery('#' + list + ' .uni-cpo-file-upload-files-item-upload').attr('disabled', false);
        window.UniCpo.setBtnState(false);
        /* </fs_premium_only> */
    },
    handlePluploadFileFiltered:   function(uploader, file) {
    },
    handlePluploadFilesAdded:     function(uploader, files) {
        /* <fs_premium_only> */
        const el = jQuery('#' + uploader.settings.multipart_params.slug + '-field');
        window.UniCpo.parsleyRemoveError(el);

        if ('single' === uploader.settings.uploadMode
            && (uploader.files.length > 1 || el.val() !== '')
        ) {
            el.parsley().addError('file-limit', { message: 'Cannot send more than 1 file.' });
            window.UniCpo.position(el, 0);
            uploader.removeFile(files[0]);
            return false;
        }

        for (let i = 0; i < files.length; i++) {
            let item = '<li class="uni-cpo-file-upload-files-item">' +
                '<i class="uni-cpo-file-upload-files-item-icon"></i>' +
                '<span class="uni-cpo-file-upload-files-item-title">' + files[i].name + '</span>' +
                '<span class="uni-cpo-file-upload-files-item-uploaded"></span>' +
                '<button class="uni-cpo-file-upload-files-item-upload"></button>' +
                '<button type="button" data-file-id="' + files[i].id + '" class="uni-cpo-file-upload-files-item-remove"></button>' +
                '<span class="uni-cpo-file-upload-files-item-progress"><span></span></span>' +
                '</li>';
            jQuery('#' + uploader.settings.listId).append(item);
        }
        //el.trigger('change');
        window.UniCpo.setBtnState(true);
        uploader.start();
        /* </fs_premium_only> */
    },
    handlePluploadBeforeUpload:   function(uploader, file) {
        /* <fs_premium_only> */
        const list = uploader.settings.listId;
        uploader.settings.multipart_params.file_name = file.name;
        jQuery('#' + list + ' .uni-cpo-file-upload-files-item-upload').attr('disabled', true);
        jQuery('#' + list + ' .uni-cpo-file-upload-files-item-remove').attr('disabled', true);
        /* </fs_premium_only> */
    },
    handlePluploadUploadProgress: function(uploader, file) {
        /* <fs_premium_only> */
        const list = uploader.settings.listId;
        jQuery('#' + list + ' .uni-cpo-file-upload-files-item-progress span').css({ 'width': file.percent + '%' });
        /* </fs_premium_only> */
    },
    handlePluploadChunkUploaded:  function(uploader, file, r) {
        const parsedResponse = JSON.parse(r.response);
        if (!parsedResponse.success) {
            const slug = uploader.settings.multipart_params.slug;
            const $option = jQuery('#' + slug + '-field');
            uploader.stop();
            $option.parsley().addError('file-upload', { message: parsedResponse.data.error });
            window.UniCpo.position($option, 0);
        }
    },
    handlePluploadFileUploaded:   function(uploader, file, r) {
        /* <fs_premium_only> */
        const id = uploader.settings.listId;
        const slug = uploader.settings.multipart_params.slug;
        const $option = jQuery('#' + slug + '-field');
        const resp = JSON.parse(r.response.replace(/\\/g, ''));
        window.UniCpo.parsleyRemoveError($option);

        if (resp.success && resp.data) {
            const attach_id = (typeof resp.data.file !== 'undefined') ? resp.data.file.id : '';
            const dropboxPath = (typeof resp.data.path_lower !== 'undefined') ? resp.data.path_lower : '';
            const optionValue = (attach_id) ? attach_id : `Dropbox: ${dropboxPath}`;
            let width = '', height = '';

            if (attach_id) {
                width = resp.data.file.width;
                height = resp.data.file.height;
            }

            jQuery('#' + id + ' .uni-cpo-file-upload-files-item-progress').remove();
            jQuery('#' + id + ' .uni-cpo-file-upload-files-item-upload').remove();
            jQuery('#' + id + ' .uni-cpo-file-upload-files-item-uploaded').show();
            jQuery('#' + id + ' .uni-cpo-file-upload-files-item-remove').attr('disabled', false);
            jQuery('[data-file-id="' + file.id + '"]')
                .data({
                    attach_id,
                    dropboxPath
                });
            $option.val(optionValue);
            $option.data({
                width,
                height
            });

            //uploader.removeFile(file); // remove from queue
            jQuery(document.body).trigger('uni_cpo_file_uploaded', [slug, resp.data.file]);
            $option.trigger('change');
        } else {
            $option.parsley().addError('file-upload', { message: resp.data.error });
            window.UniCpo.position($option, 0);
        }
        window.UniCpo.setBtnState(false);
        /* </fs_premium_only> */
    },
    hexToRgb:                     function(hex) {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    },
    gMapMarkers:                  {},
    addGoogleMarker:              function(location, map, mapId) {
        /* <fs_premium_only> */
        const cpoObj = window.UniCpo;
        const marker = new google.maps.Marker({
            position: location,
            map:      map
        });

        if (!cpoObj.gMapMarkers.hasOwnProperty(mapId)) {
            cpoObj.gMapMarkers[mapId] = [];
        }

        if (cpoObj.gMapMarkers[mapId].length) {
            for (let marker in cpoObj.gMapMarkers[mapId]) {
                cpoObj.gMapMarkers[mapId][marker].setMap(null);
            }
            cpoObj.gMapMarkers[mapId] = [];
        }

        cpoObj.gMapMarkers[mapId].push(marker);
        /* </fs_premium_only> */
    },
    initGoogleMap:                function() {
        /* <fs_premium_only> */
        try {
            const cpoObj = window.UniCpo;
            const gMapContainers = document.getElementsByClassName('js-uni-gmap-container');

            if (!gMapContainers.length) {
                return;
            }

            for (let map of gMapContainers) {
                const existingMap = map.getAttribute('data-map');

                if (null != existingMap) {
                    //google.maps.event.trigger(existingMap, 'resize');
                    //const hiddenLatLng = map.nextElementSibling;
                    //hiddenLatLng.value = '';
                    //hiddenLatLng.nextElementSibling.value = '';
                }

                const slug = map.getAttribute('data-slug');
                const coordsArr = map.getAttribute('data-coords').split(',');
                const lat = parseFloat(coordsArr[0]);
                const lng = parseFloat(coordsArr[1]);
                const gMap = new google.maps.Map(map, {
                    center: { lat, lng },
                    zoom:   parseInt(map.getAttribute('data-zoom'))
                });
                map.setAttribute('data-map', gMap);

                gMap.addListener('click', function(event) {
                    cpoObj.addGoogleMarker(event.latLng, gMap, slug);
                    cpoObj.geocoder.geocode({
                        'latLng': event.latLng
                    }, function(results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[0]) {
                                const address = document.getElementById(`js-uni-cpo-field-${slug}`);
                                const latlng = document.getElementById(`js-uni-cpo-field-${slug}-latlng`);

                                if (null != address) {
                                    address.value = results[0].formatted_address;
                                }
                                if (null != latlng) {
                                    latlng.value = event.latLng;
                                }
                            }
                        }
                    });
                });

            }
        } catch (err) {
            console.error(err);
        }
        /* </fs_premium_only> */
    },
    initRangeSlider:              function() {
        /* <fs_premium_only> */
        const cpoObj = this;
        const sliders = jQuery('.js-uni-cpo-field-range_slider');

        sliders.each(function() {
            const $el = jQuery(this);
            const $input = $el.siblings(jQuery('.js-uni-cpo-field-range_slider-additional-field'));

            const options = {
                force_edges:            true,
                input_values_separator: '-',
                onFinish:               function(data) {
                    if ($input.length) {
                        if (!data.from_value) {
                            $input.val(data.from);
                        } else {
                            $input.val(data.from_value);
                        }
                    }

                    if (cpoObj._ajax_sent) {
                        return false;
                    }
                    if (!cpoObj.calc || (cpoObj.calc && !cpoObj.calcBtn)) {
                        cpoObj.processFormData();
                    } else if (cpoObj.calc && cpoObj.calcBtn) {
                        cpoObj.setBtnState(true);
                        cpoObj.collectData(true);
                    }
                },
                onUpdate:               function() {
                    if (cpoObj._ajax_sent) {
                        return false;
                    }
                    if (!cpoObj.calc || (cpoObj.calc && !cpoObj.calcBtn)) {
                        cpoObj.processFormData();
                    } else if (cpoObj.calc && cpoObj.calcBtn) {
                        cpoObj.setBtnState(true);
                        cpoObj.collectData(true);
                    }
                }
            };
            $el.ionRangeSlider(options);

            if ($input.length) {
                $input.on('change', function() {
                    const slider = $el.data('ionRangeSlider');
                    const values = $el.attr('data-values');
                    const step = Number($el.attr('data-step'));
                    const min = Number($el.attr('data-min'));
                    const max = Number($el.attr('data-max'));
                    const val = jQuery(this).val();
                    let value;

                    if (!values.length) {
                        if (step) {
                            value = val < min ? min : val > max ? max : Math.floor(Number(val) / step) * step + ((Number(val) % step) >= step / 2 ? step : 0);
                        } else {
                            value = val < min ? min : val > max ? max : val;
                        }
                    } else {
                        value = values.split(',').map(function(el) {
                            return el.toLowerCase();
                        }).indexOf(val.toLowerCase());
                    }

                    slider.update({
                        from: value
                    });
                    jQuery(this).val(value);
                });
            }
        });
        /* </fs_premium_only> */
    },
    isMobile:                     function() {
        const Uagent = navigator.userAgent || navigator.vendor || window.opera;
        return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(Uagent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(Uagent.substr(0, 4)));
    },
    initTooltip:                  function() {
        jQuery('.uni-builderius-container').tooltip({
            items:    '[data-tip]',
            show:     {
                effect:   'show',
                duration: 0
            },
            hide:     {
                effect:   'fad',
                duration: 0
            },
            close:    function() {
                jQuery('.ui-helper-hidden-accessible').remove();
            },
            position: {
                my:        'center bottom',
                at:        'center top-10',
                collision: 'none',
                using:     function(position, feedback) {
                    jQuery(this).css(position);
                    jQuery(this).addClass('vertical-bottom horizontal-center');
                }
            },
            content:  function() {
                return jQuery(this).attr('data-tip');
            }
        });
    },
    isNumber:                     (val) => !isNaN(parseFloat(val)) && isFinite(val),
    position:                     function(el, delay) {
        let time;
        let $parent = el;
        let $list;

        if (typeof delay !== 'undefined') {
            time = delay;
        } else {
            time = 300;
        }

        if (el.hasClass('uni-module')) {
            $list = el.find('.parsley-errors-list');
        } else {
            $list = jQuery('#parsley-id-' + $parent.data('parsley-id'));
            if ($parent.attr('type') === 'hidden') {
                $parent = jQuery('' + el.data('parsley-class-handler'));
            }
        }

        if (!el.hasClass('parsley-error')
            && typeof el.data('parsley-errors-container') !== 'undefined'
            && typeof el.data('parsley-class-handler') !== 'undefined'
            && el.attr('type') !== 'hidden') {

            $parent = jQuery('' + el.data('parsley-class-handler'));
            $list = jQuery('[id="parsley-id-multiple-' + $parent.attr('id') + '"]');
        }

        let width = $parent.outerWidth();

        setTimeout(function() {
            $list.position({
                of:        $parent,
                my:        'left top',
                at:        'left bottom',
                collision: 'none'
            });
            $list.css({
                'max-width': width,
                'opacity':   1
            });
        }, time);
    },
    processFormData:              function() {
        if (!this.addToCartBtnEl.length) {
            return false;
        }

        const cpoObj = this;
        let formValid = false;

        cpoObj.collectData(true);
        if (this.calc) {
            cpoObj.setPriceTo({ price: cpoObj.priceStartingEl });
            /* <fs_premium_only> */
            cpoObj.setPriceTaxRevTo({ price: cpoObj.priceStartingEl });
            /* </fs_premium_only> */
        }

        // Triggers an event - on form data process has been started
        jQuery(document.body).trigger('uni_cpo_form_data_process_start', [cpoObj]);

        // validates
        cpoObj.productFormEl.parsley({ excluded: '[disabled], .qty, .uni-cpo-excluded-field' }).validate();
        if (cpoObj.productFormEl.parsley().isValid()) {
            formValid = true;
        }

        let fields = cpoObj.getFormattedFormData(false);

        // validates again
        cpoObj.productFormEl.parsley({ excluded: '[disabled], .qty, .uni-cpo-excluded-field' }).validate();
        if (cpoObj.productFormEl.parsley().isValid()) {
            formValid = true;
        }

        if (formValid && fields['product_id']) {
            jQuery(document.body).trigger('uni_cpo_options_data_after_validate_event', [fields]);
            if (!cpoObj.calc) {
                cpoObj.setBtnState(false);
            }
            if (cpoObj.calc && !cpoObj.calcBtn) {
                cpoObj.setBtnState(true);
            }
            if (cpoObj.calc) {
                cpoObj.calculate(fields);
            }
        } else {
            cpoObj.setBtnState(true);
            jQuery(document.body).trigger('uni_cpo_options_data_not_valid_event', [fields]);
        }
    },
    replaceMainImageData:         function(data) {
        /* <fs_premium_only> */
        const cpoObj = this;

        if (!this.mainImageEl) {
            console.info('Uni CPO @', 'No main image found.');
            return;
        }

        const $a = this.mainImageEl.find('a');
        const $img = $a.find('img');
        const $zoom = $a.next('img.zoomImg').length > 0
            ? $a.next('img.zoomImg')
            : '';
        const $thumb = jQuery(unicpo.thumbs_selector).children().first().find('img');
        const $viewport = this.mainImageEl.closest('div[class*="viewport"]');

        let {
                imgId,
                imgFullUri,
                imgTitle,
                imgAlt,
                imgUri,
                imgSrcset,
                imgSizes,
                imgSrc,
                imgLarge_image,
                imgLarge_image_width,
                imgLarge_image_height,
                imgThumbUri,
                imgWidth,
                imgHeight
            } = data;

        $img.closest('div').attr('data-thumb', imgThumbUri);

        $img.parent().attr('href', imgFullUri);
        $img.parent().attr('title', imgTitle);

        $img.attr('title', imgTitle);
        $img.attr('alt', imgAlt);
        $img.attr('src', imgUri);
        $img.attr('data-src', imgSrc);
        $img.attr('data-large_image', imgLarge_image);
        $img.attr('data-large_image_width', imgLarge_image_width);
        $img.attr('data-large_image_height', imgLarge_image_height);
        $img.attr('sizes', imgSizes);
        if (!imgSrcset) {
            imgSrcset = '';
        }
        $img.attr('srcset', imgSrcset);
        $img.attr('width', imgWidth);
        $img.attr('height', imgHeight);

        if ($zoom) {
            $zoom.attr('src', imgFullUri);
        }

        $thumb.attr('src', imgThumbUri);

        const interval = setInterval(function() {
            const height = $img.height();
            $viewport.css('height', height);
            cpoObj.showFirstThumbOnImageChange();
            clearInterval(interval);
        }, 100);

        if (imgId) {
            this.productFormEl.find('.js-cpo-product-image').val(imgId);
        }

        // Triggers an event
        jQuery(document.body).trigger('uni_cpo_options_product_image_replaced_event', [data, $img]);
        /* </fs_premium_only> */
    },
    parsleyRemoveError:           function(el) {
        el.parsley().removeError('file-limit');
        el.parsley().removeError('file-type');
        el.parsley().removeError('file-size');
        el.parsley().removeError('file-custom');
        el.parsley().removeError('file-upload');
    },
    replaceLabelsWithDynamicData: function(data) {
        /* <fs_premium_only> */
        try {
            const regex = /({#)|(#})/g;
            Object.keys(data)
                .filter(k => !isNil(data[k].is_dynamic_label) && data[k].is_dynamic_label)
                .map((k) => {
                    let tooltip = {};
                    const label = jQuery(`#${k}:not(.uni-module-radio):not(.uni-module-checkbox) > label`);
                    const tooltipEl = label.find(`.uni-cpo-tooltip`);
                    if (tooltipEl.length) {
                        tooltip = tooltipEl[0];
                    }
                    label.text(data[k].label);
                    label.text(data[k].label.replace(regex, ''));
                    if (!isEmpty(tooltip)) {
                        label.append(tooltip);
                    }

                    if (!isEmpty(data[k].suboptions)) {
                        if (data[k].type === 'radio') {
                            let desc = { [k]: {} };
                            let tooltip = {};
                            Object.keys(data[k].suboptions).map((s) => {
                                const descEl = jQuery(`[for=${k}-field-${s}] span.uni-cpo-option-label__text > span.uni-cpo-option-label__description`);
                                if (descEl.length) {
                                    desc[k][s] = descEl;
                                }
                            });
                            const label = jQuery(`#${k} > label.uni-cpo-module-radio-label`);
                            const tooltipEl = label.find(`.uni-cpo-tooltip`);
                            if (tooltipEl.length) {
                                tooltip = tooltipEl[0];
                            }
                            label.text(data[k].label.replace(regex, ''));
                            if (!isEmpty(tooltip)) {
                                label.append(tooltip);
                            }
                            Object.keys(data[k].suboptions).map((s) => {
                                const label = jQuery(`[for=${k}-field-${s}] span.uni-cpo-option-label__text`);
                                if (label.length) {
                                    label.text(data[k].suboptions[s].label.replace(regex, ''));
                                    if (!isNil(desc[k]) && !isNil(desc[k][s])) {
                                        label.append(desc[k][s]);
                                    }
                                }
                            });
                        } else if (data[k].type === 'select') {
                            const field = document.getElementById(`${k}-field`);
                            if (!isNil(field) && !isNil(field.options)) {
                                [...field.options].map((opt) => {
                                    if (!isEmpty(opt.value)) {
                                        opt.innerHTML = data[k].suboptions[opt.value].label.replace(regex, '');
                                    }
                                });
                            }
                        } else if (data[k].type === 'checkbox') {
                            let desc = { [k]: {} };
                            let tooltip = {};

                            Object.keys(data[k].suboptions).map((s) => {
                                const label = jQuery(`[for=${k}-field-${s}] span.uni-cpo-option-label__text`);
                                const descEl = label.find(`span.uni-cpo-option-label__description`);
                                if (descEl.length) {
                                    desc[k][s] = descEl;
                                }
                            });
                            const label = jQuery(`#${k} > label.uni-cpo-module-checkbox-label`);
                            const tooltipEl = label.find(`.uni-cpo-tooltip`);
                            if (tooltipEl.length) {
                                tooltip = tooltipEl[0];
                            }
                            label.text(data[k].label.replace(regex, ''));
                            if (!isEmpty(tooltip)) {
                                label.append(tooltip);
                            }
                            Object.keys(data[k].suboptions).map((s) => {
                                const label = jQuery(`[for=${k}-field-${s}] span.uni-cpo-option-label__text`);

                                if (label.length) {
                                    label.text(data[k].suboptions[s].label.replace(regex, ''));
                                    if (!isNil(desc[k]) && !isNil(desc[k][s])) {
                                        label.append(desc[k][s]);
                                    }
                                }
                            });
                        }
                    }

                });
        } catch (err) {
            console.error(err);
        }
        /* </fs_premium_only> */
    },
    setBtnState:                  function(state) {
        this.addToCartBtnEl.prop('disabled', state);
        jQuery(document.body).trigger('uni_cpo_set_btn_state_event', [state]);
    },
    setPriceTo:                   function({ price, tax = 'starting' }) {
        const cpoObj = this;
        const $el = cpoObj.priceTagEl;
        $el.each(function(i, elInList) {
            jQuery(elInList).parent().each(function(k, elInListParent) {
                if (jQuery(elInListParent)[0].tagName === 'DEL') {
                    jQuery(elInListParent).find(elInList).show();
                } else {
                    jQuery(elInListParent).find(elInList).each(function() {
                        let cloned = price;
                        if (typeof price === 'object') {
                            cloned = price.clone();
                        }
                        jQuery(this).html(cloned).show();
                        jQuery(document.body).trigger('uni_cpo_set_price_event', [cloned]);
                    });
                    if (cpoObj.isTaxable && tax !== 'hide') {
                        const $taxSuffixEl = jQuery(elInListParent).find(cpoObj.taxPriceSuffixElClass);
                        const $newTaxSuffixEl = jQuery(cpoObj.getProperTaxSuffix(tax));
                        $taxSuffixEl.replaceWith($newTaxSuffixEl);
                        $newTaxSuffixEl.show();
                        $newTaxSuffixEl.find('span').show();
                    } else {
                        jQuery(elInListParent).find(cpoObj.taxPriceSuffixElClass).hide();
                    }
                }
            });
        });
    },
    setPriceTaxRevTo: function({ price }) {
        /* <fs_premium_only> */
        const cpoObj = this;
        const $el = cpoObj.priceTaxRevTagEl;
        $el.each(function(i, elInList) {
            jQuery(elInList).parent().each(function(k, elInListParent) {
                if (jQuery(elInListParent)[0].tagName === 'DEL') {
                    jQuery(elInListParent).find(elInList).show();
                } else {
                    jQuery(elInListParent).find(elInList).each(function() {
                        let cloned = price;
                        if (typeof price === 'object') {
                            cloned = price.clone();
                        }
                        jQuery(this).html(cloned).show();
                        jQuery(document.body).trigger('uni_cpo_set_price_tax_rev_event', [cloned]);
                    });
                }
            });
        });
        /* </fs_premium_only> */
    },
    showFirstThumbOnImageChange:  function() {
        /* <fs_premium_only> */
        const slider_data = jQuery('.woocommerce-product-gallery').data('flexslider');
        if (typeof slider_data !== 'undefined') {
            slider_data.flexslider(0);
        }
        /* </fs_premium_only> */
    },
    showLastThumb:                function() {
        /* <fs_premium_only> */
        const lastSlideIndex = jQuery('.flex-control-thumbs li').index(jQuery('.flex-control-thumbs li:last'));
        if (jQuery.flexslider) {
            jQuery('.woocommerce-product-gallery').flexslider(lastSlideIndex);
        }
        const flickty = jQuery('.woocommerce-product-gallery__wrapper').data('flickity');
        if (typeof flickty !== 'undefined' && flickty.slides.length > 1) {
            flickty.select(flickty.slides.length - 1);
        }
        /* </fs_premium_only> */
    },
    getProperPrice:               function({ price = '', doRemoveSuffix = false } = {}) {
        let initPrice = (this.priceStarting && !price)
            ? this.priceStarting
            : (price) ? price : unicpo.price_vars.price;
        /* <fs_premium_only> */
        if (!doRemoveSuffix) {
            initPrice = (this.priceSuffix) ? `${this.priceSuffix} ${initPrice}` : initPrice;
        }
        initPrice = (this.pricePostfix) ? `${initPrice} ${this.pricePostfix}` : initPrice;
        /* </fs_premium_only> */

        return initPrice;
    },
    getProperTaxSuffix:           function(tax) {
        if (tax === 'starting') {
            return this.priceTaxSuffixStarting;
        } else if (tax === 'show') {
            return unicpo.price_vars.price_tax_suffix;
        }
    },
    template:                     _.memoize(function(id) {
        let compiled;
        const options = {
            evaluate:    /\{#([\s\S]+?)#\}/g,
            interpolate: /\{\{\{([\s\S]+?)\}\}\}/g,
            escape:      /\{\{([^\}]+?)\}\}(?!\})/g,
            variable:    'data'
        };

        return function(data) {
            compiled = compiled || _.template(jQuery('#cpo-tmpl-' + id).html(), options);
            return compiled(data);
        };
    }),
    _blockForm:                   function(el) {
        this._ajax_sent = true;
        jQuery(el).block({
            message:    '<div data-loader="circle"></div>',
            css:        {
                width:  'auto',
                border: '0px'
            },
            overlayCSS: {
                background: '#fff',
                opacity:    0.6
            }
        });
    },
    _unblockForm:                 function(el, type) {
        this._ajax_sent = false;
        jQuery(el).unblock();
    },
    isProp:                       (obj, prop) => {
        return obj[prop] != null && typeof obj[prop] !== 'undefined';
    },
    isDateBetween:                (start, end, target) => {
        const d1 = Date.parse(start);
        const d2 = Date.parse(end);
        const dTarget = Date.parse(target);
        return dTarget >= d1 && dTarget <= d2;
    },
    fpdCompat:                    function() {
        const options = document.querySelectorAll('.fpdEnabled');
        const initial = { name: '', value: '' };
        [...options].forEach((el) => {
            const fields = el.querySelectorAll('input, select');
            [...fields].forEach(elem => elem.addEventListener('change', (e) => {
                const { name, value } = e.target;
                this.updateFpd(name, value);
            }));
            [...fields].forEach((elem) => {
                const { name, value } = elem;
                if (value) {
                    initial.name = name;
                    initial.value = value;
                }
            });
        });

        setTimeout(() => {
            this.updateFpd(...Object.values(initial));
        }, 1200);
    },
    updateFpd:                    function(name, value) {
        if (isNil(window.fpdProductCreated)) {
            return;
        }
        const { fpdProductCreated } = window;
        const prod = pathOr(null, [name, 'suboptions', value, 'rate'], window.unicpoAllOptions);
        if (!isNil(prod) && fpdProductCreated) {

            fancyProductDesigner.toggleSpinner(true, 'loading product');

            var data = {
                action:     'fpd_load_product',
                product_id: prod
            };

            jQuery.post(
                unicpo.ajax_url,
                data,
                function(response) {

                    if (typeof response === 'object') {

                        if (response.length == 0) {

                            alert('The product does not exists or has no views!');
                            fancyProductDesigner.toggleSpinner(false);
                            return;

                        }

                        fancyProductDesigner.loadProduct(
                            response,
                            true,
                            true
                        );
                    } else {
                        FPDUtil.showMessage('product loading failed');
                    }

                }, 'json');

        }
    }
};

cpoMakeInstance = () => Object.create(UniCpo);
window.UniCpo = cpoMakeInstance();

// init
window.UniCpo._init();

/* Custom ParsleyJS validators
----------------------------------------------------------*/

window.Parsley.addValidator('maxFileSize', {
    validateString:  function(_value, maxSize, parsleyInstance) {
        if (!window.FormData) {
            console.log('The browser does not support this feature');
            return true;
        }
        if (0 === maxSize) {
            maxSize = unicpo.max_file_size;
        }
        const files = parsleyInstance.$element[0].files;
        return files.length !== 1 || files[0].size <= maxSize * 1024;
    },
    requirementType: 'integer',
    messages:        {
        en: unicpo_i18n.max_file_size
    }
});

window.Parsley.addValidator('mimeType', {
    validateString:  function(value, requirement, parsleyInstance) {

        const files = parsleyInstance.$element[0].files;
        if (0 === files.length) {
            return true;
        }

        if ('' === requirement) {
            requirement = unicpo.mime_type;
        }
        const allowedMimeTypes = requirement.replace(/\s/g, '').split(',');
        return allowedMimeTypes.indexOf(files[0].type) !== -1;

    },
    requirementType: 'string',
    messages:        {
        en: unicpo_i18n.mime_type
    }
});

window.Parsley
    .addValidator('greaterorequalthan', {
        requirementType: 'string',

        validateNumber(value, requirement) {
            const comp_value = jQuery(requirement).val();
            return value >= comp_value;
        },

        messages: {
            en: 'This value should be greater or equal than %s'
        }
    });

window.Parsley
    .addValidator('greaterthan', {
        requirementType: 'string',

        validateNumber(value, requirement) {
            const comp_value = jQuery(requirement).val();
            return value > comp_value;
        },

        messages: {
            en: 'This value should be greater than %s'
        }
    });

window.Parsley
    .addValidator('lessorequalthan', {
        requirementType: 'string',

        validateNumber(value, requirement) {
            const comp_value = jQuery(requirement).val();
            return value <= comp_value;
        },

        messages: {
            en: 'This value should be less or equal than %s'
        }
    });

window.Parsley
    .addValidator('lessthan', {
        requirementType: 'string',

        validateNumber(value, requirement) {
            const comp_value = jQuery(requirement).val();
            return value < comp_value;
        },

        messages: {
            en: 'This value should be less than %s'
        }
    });

window.Parsley.on('field:error', function() {
    if (window.UniCpo.isSilentValidationOn) {
        this.removeError('required');
    }
    window.UniCpo.position(this.$element);
});

/* Custom JS functions-helpers
----------------------------------------------------------*/

/* Custom JS functions-helpers to be used in Dynamic Notice
----------------------------------------------------------*/
window.uniData = (data) => ({
    data,
    init() {
        if (typeof data !== 'undefined') {
            Object.assign(this, data);
        }
    },
    checkExistance(prop) {
        if (typeof this[prop] !== 'undefined') {
            return true;
        } else {
            return false;
        }
    },
    getLabel(prop) {
        if (typeof unicpoAllOptions[prop] !== 'undefined' && typeof unicpoAllOptions[prop]['label'] !== 'undefined') {
            return unicpoAllOptions[prop]['label'];
        }

        return '';
    },
    getCartLabel(prop) {
        if (typeof unicpoAllOptions[prop] !== 'undefined' && typeof unicpoAllOptions[prop]['cartLabel'] !== 'undefined') {
            return unicpoAllOptions[prop]['cartLabel'];
        }

        return '';
    },
    getSuboptionLabel(prop) {
        if (typeof unicpoAllOptions[prop] !== 'undefined' && typeof unicpoAllOptions[prop].suboptions[this[prop]] !== 'undefined') {
            return unicpoAllOptions[prop].suboptions[this[prop]]['label'];
        } else if (typeof unicpoAllOptions[prop] !== 'undefined' && Array.isArray(this[prop])) {
            let label = '';

            this[prop].forEach((item) => {
                label += `, ${unicpoAllOptions[prop].suboptions[item]['label']}`;
            });

            return label.substr(2);
        }

        return '';
    },
    asPrice(prop) {
        const exists = this.checkExistance(prop);
        return exists && typeof this[prop] !== 'undefined' ?
            parseFloat(this[prop]).toFixed(2) :
            parseFloat(0).toFixed(2);
    },
    asNumber(prop, precision = 2) {
        const exists = this.checkExistance(prop);
        return exists && typeof this[prop] !== 'undefined' ?
            parseFloat(this[prop]).toFixed(precision) :
            parseFloat(0).toFixed(precision);
    }
});
